@if (data$ | async; as data) {
  <app-custom-navigation-ui
    [node]="node$ | async"
    [ngClass]="data.styleClass"
    [wrapAfter]="data.wrapAfter"
    [isMenu]="true"
    [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"
  ></app-custom-navigation-ui>
}
